module.exports = __webpack_public_path__ + "static/media/step2inactive.f5aedbe0.svg";